export default __webpack_public_path__ + "static/industrials-5afdb87787f9b5e758530c41925a9980.png";